var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { Modal } from '@doordash/component-modal';
import { StackChildren, InlineChildren, Text } from '@doordash/design-language';
import Button from '@doordash/component-button';
import styled from 'styled-components';
import PaymentStrings from '../PaymentStrings';
import { CONTACT_SUPPORT_URL } from '../../../../constants/values';
export var ButtonGroupContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 300px;\n"], ["\n  max-width: 300px;\n"])));
export var PaymentMethodLimitReachedModal = function (_a) {
    var onClose = _a.onClose;
    return (React.createElement(Modal, { onClose: onClose, title: PaymentStrings.paymentLimitModalTitle() },
        React.createElement(StackChildren, { size: StackChildren.Sizes.Small },
            React.createElement(Text, { color: Text.Colors.TextSecondary }, PaymentStrings.paymentLimitModalDescription()),
            React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center, justifyContent: InlineChildren.Justification.FlexEnd },
                React.createElement(ButtonGroupContainer, null,
                    React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center },
                        React.createElement(Button, { type: Button.Types.TertiaryPill, onClick: onClose }, PaymentStrings.paymentLimitModalCancelButtonText()),
                        React.createElement(Button, { type: Button.Types.PrimaryPill, href: CONTACT_SUPPORT_URL, tag: "a", target: "_blank" }, PaymentStrings.paymentLimitModalContactSupportButtonText())))))));
};
export default PaymentMethodLimitReachedModal;
var templateObject_1;
